import React from 'react';
import styles from './StepProgress.module.css';

/**
 * 卡片内步骤进度（只展示，不可点击跳转）
 */
export default function StepProgress({ current = 1, compact = false }) {
  const step1Active = current === 1;
  const step1Done = current > 1;
  const step2Active = current === 2;

  return (
    <div
      className={[styles.progress, compact && styles.progressCompact].filter(Boolean).join(' ')}
      aria-label={`当前步骤 ${current}，共 2 步`}
    >
      <div
        className={[
          styles.item,
          step1Active && styles.itemActive,
          step1Done && styles.itemDone,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <span className={styles.dot}>1</span>
        基本信息
      </div>
      <span
        className={[styles.connector, step1Done && styles.connectorDone].filter(Boolean).join(' ')}
        aria-hidden="true"
      />
      <div className={[styles.item, step2Active && styles.itemActive].filter(Boolean).join(' ')}>
        <span className={styles.dot}>2</span>
        工装申领
      </div>
    </div>
  );
}
